import { Grid } from "@mui/material";
import { useEffect, useRef } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import H1 from "ReusableComponents/Text/H1";
import H2 from "ReusableComponents/Text/H2";
import Span from "ReusableComponents/Text/Span";
import { COLORS, SIZES, WEIGHT } from "theme";

const Sections = ({
  img,
  name,
  heading,
  description,
  features,
  inverse,
  color,
  noDesc,
  fromCharging,
  subtitle,
  isHiload,
  id,
  small,
  hideIcons,
  onValueUpdate,
  fromCareer,
  medium,
}) => {
  const sectionRef = useRef(null);
  const handleButtonClick = (value) => {
    // Simulate an updated value (this could be anything dynamic)
    const updatedValue = value;
    // Trigger the callback with the new value
    onValueUpdate(updatedValue);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          handleButtonClick(name);
          console.log(`User is viewing section: ${name}`);
        } else {
          // Section is out of view
          handleButtonClick("");
          console.log(`User has moved away from section: ${name}`);
        }
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [name]);
  return (
    <div ref={sectionRef}>
      <Box
        h={small ? "400px" : "589px"}
        w="100%"
        background={`url(${
          !small ? (isHiload ? img : img) : fromCareer ? img : img
        })`}
        style={{
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          display: "flex",
          backgroundPosition: "center",
        }}
        position="relative"
        paddingTop={fromCharging && "80px"}
        id={id}
        zIndex={1}
      >
        <Box
          display="flex"
          justifyContent={inverse ? "flex-end" : "start"}
          alignItems="end"
          w="inherit"
          textAlign={inverse ? "right" : "left"}
        >
          <Box margin={small ? "20px" : "40px 80px"}>
            <Box padding={small ? SIZES.twelve : "6px 24px"} w="fit-content">
              <Box marginBottom={small ? 0 : "2rem"}>
                {isHiload ? (
                  <H2
                    w="fit-content"
                    display="flex"
                    flexDirection="column"
                    marginBottom={small ? SIZES.twelve : SIZES.twenty}
                  >
                    <Span
                      fontSize={small ? SIZES.twentyFour : SIZES.forty}
                      w="fit-content"
                      textAlign="center"
                      textColor="white"
                      fontWeight="bold"
                      padding={small ? "0.2em" : "0.3em"}
                    >
                      {name}
                    </Span>
                    <br/>
                    <Span
                      fontSize={small ? SIZES.twentyFour : SIZES.forty}
                      padding={small ? "0.2em" : "0.3em"}
                      background={COLORS.black}
                      textColor="white"
                      w="fit-content"
                      fontWeight="bold"
                      textAlign="center"
                      marginLeft="1em"
                    >
                      {subtitle}
                    </Span>
                  </H2>
                ) : (
                  <H1
                    w="fit-content"
                    display="flex"
                    flexDirection="column"
                    marginBottom={small ? SIZES.twelve : SIZES.twenty}
                  >
                    {/* <div style={{ background: "black" }}> */}
                      <H1
                        fontSize={small ? SIZES.twenty : SIZES.forty}
                        w="fit-content"
                        textAlign="center"
                        textColor="white"
                        background="transparent"
                        fontWeight="bold"
                        padding={small ? "5px" : "10px"}
                        style={{ margin: "0",background:"black" }}
                      >
                        {name}
                      </H1>
                    {/* </div> */}

                    <Span
                      fontSize={small ? SIZES.twenty : SIZES.forty}
                      padding={small ? "5px" : "10px"}
                      background={COLORS.black}
                      textColor="white"
                      w="fit-content"
                      fontWeight="bold"
                      textAlign="center"
                      marginLeft="1em"
                    >
                      {heading}
                    </Span>
                  </H1>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box background={COLORS.lightBlack}>
        <Grid
          container
          spacing={2}
          style={{ padding: small ? "40px" : "40px 80px 80px 80px" }}
        >
          {inverse ? (
            <>
              {small || medium ? (
                <>
                  <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                    <Box
                      w={small ? "auto" : "auto"}
                      marginBottom={small && SIZES.twenty}
                    >
                      <Text
                        fontWeight={WEIGHT[small ? "regular" : "bold"]}
                        fontSize={small ? "14px" : "22px"}
                        textColor={COLORS.lightGrey}
                        lineHeight="2"
                        margin="0"
                      >
                        {description}
                      </Text>
                    </Box>
                  </Grid>
                  {!hideIcons && (
                    <Grid item xs={12} md={6} style={{ paddingTop: 4 }}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="start"
                        >
                          <Grid container spacing={2}>
                            <Grid item xs={12} lg={6}>
                              <Box display="flex" flexDirection={"column"}>
                                <Box
                                  display="flex"
                                  justifyContent={"start"}
                                  alignItems="center"
                                  marginBottom={
                                    small || medium ? "20px" : "48px"
                                  }
                                >
                                  <LazyLoadImage
                                    effect="blur"
                                    src={features[0].img}
                                    alt={features[0].alt}
                                    style={{
                                      marginRight: 12,
                                      filter: "invert(1)",
                                    }}
                                  />

                                  <Text
                                    fontSize={small ? "12px" : "20px"}
                                    textColor={color ? color : "#707070"}
                                    margin="0"
                                    width="217px"
                                  >
                                    {features[0].title}
                                  </Text>
                                </Box>
                                <Box
                                  display="flex"
                                  justifyContent={"start"}
                                  alignItems="center"
                                >
                                  <img
                                    src={features[1].img}
                                    alt={features[1].alt}
                                    style={{
                                      marginRight: 12,
                                      filter: "invert(1)",
                                    }}
                                  />
                                  <Text
                                    fontSize={small ? "12px" : "20px"}
                                    margin="0"
                                    width="217px"
                                    textColor={color ? color : "#707070"}
                                  >
                                    {features[1].title}
                                  </Text>
                                </Box>
                              </Box>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Box
                                display="flex"
                                flexDirection={"column"}
                                marginLeft={small || medium ? 0 : "40px"}
                              >
                                <Box
                                  display="flex"
                                  justifyContent="start"
                                  alignItems="center"
                                  marginBottom={
                                    small || medium ? "20px" : "48px"
                                  }
                                >
                                  <LazyLoadImage
                                    effect="blur"
                                    src={features[2].img}
                                    alt={features[2].alt}
                                    style={{
                                      marginRight: 12,
                                      filter: "invert(1)",
                                    }}
                                  />
                                  <Text
                                    fontSize={small ? "12px" : "20px"}
                                    textColor={color ? color : "#707070"}
                                    margin="0"
                                    width="217px"
                                  >
                                    {features[2].title}
                                  </Text>
                                </Box>
                                {!isHiload && (
                                  <Box
                                    display={!isHiload ? "flex" : "none"}
                                    justifyContent="start"
                                    alignItems="center"
                                  >
                                    <LazyLoadImage
                                      effect="blur"
                                      src={features[3].img}
                                      alt={features[3].alt}
                                      style={{
                                        marginRight: 12,
                                        filter: "invert(1)",
                                      }}
                                    />
                                    <Text
                                      fontSize={small ? "12px" : "20px"}
                                      textColor={color ? color : "#707070"}
                                      margin="0"
                                      width="217px"
                                    >
                                      {features[3].title}
                                    </Text>
                                  </Box>
                                )}
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    </Grid>
                  )}
                </>
              ) : (
                <>
                  <Grid item xs={12} md={6} style={{ paddingTop: 4 }}>
                    {!hideIcons && (
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="left"
                      >
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="start"
                        >
                          <Grid container spacing={2}>
                            <Grid item xs={12} lg={6}>
                              <Box display="flex" flexDirection={"column"}>
                                <Box
                                  display="flex"
                                  justifyContent={"start"}
                                  alignItems="center"
                                  marginBottom={
                                    small || medium ? "20px" : "48px"
                                  }
                                >
                                  <img
                                    src={features[0].img}
                                    alt={features[0].alt}
                                    style={{
                                      marginRight: 12,
                                      filter: "invert(1)",
                                    }}
                                  />

                                  <Text
                                    fontSize={small ? "12px" : "20px"}
                                    textColor={color ? color : "#707070"}
                                    margin="0"
                                    width="217px"
                                  >
                                    {features[0].title}
                                  </Text>
                                </Box>
                                <Box
                                  display="flex"
                                  justifyContent={"start"}
                                  alignItems="center"
                                >
                                  <img
                                    src={features[1].img}
                                    alt={features[1].alt}
                                    style={{
                                      marginRight: 12,
                                      filter: "invert(1)",
                                    }}
                                  />
                                  <Text
                                    fontSize={small ? "12px" : "20px"}
                                    margin="0"
                                    width="217px"
                                    textColor={color ? color : "#707070"}
                                  >
                                    {features[1].title}
                                  </Text>
                                </Box>
                              </Box>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <Box
                                display="flex"
                                flexDirection={"column"}
                                marginLeft={small || medium ? 0 : "40px"}
                              >
                                <Box
                                  display="flex"
                                  justifyContent="start"
                                  alignItems="center"
                                  marginBottom={
                                    small || medium ? "20px" : "48px"
                                  }
                                >
                                  <img
                                    src={features[2].img}
                                    alt={features[2].alt}
                                    style={{
                                      marginRight: 12,
                                      filter: "invert(1)",
                                    }}
                                  />
                                  <Text
                                    fontSize={small ? "12px" : "20px"}
                                    textColor={color ? color : "#707070"}
                                    margin="0"
                                    width="217px"
                                  >
                                    {features[2].title}
                                  </Text>
                                </Box>
                                {!isHiload && (
                                  <Box
                                    display={!isHiload ? "flex" : "none"}
                                    justifyContent="start"
                                    alignItems="center"
                                  >
                                    <img
                                      src={features[3].img}
                                      alt={features[3].alt}
                                      style={{
                                        marginRight: 12,
                                        filter: "invert(1)",
                                      }}
                                    />
                                    <Text
                                      fontSize={small ? "12px" : "20px"}
                                      textColor={color ? color : "#707070"}
                                      margin="0"
                                      width="217px"
                                    >
                                      {features[3].title}
                                    </Text>
                                  </Box>
                                )}
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    )}
                  </Grid>

                  <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                    <Box w={"auto"} marginBottom={small && SIZES.twenty}>
                      <Text
                        fontWeight={WEIGHT[small ? "regular" : "bold"]}
                        fontSize={small ? "14px" : "22px"}
                        textColor={small || medium ? COLORS.lightGrey : "white"}
                        lineHeight="2"
                        margin="0"
                      >
                        {description}
                      </Text>
                    </Box>
                  </Grid>
                </>
              )}
            </>
          ) : (
            <>
              <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                <Box
                  w={small || medium ? "auto" : hideIcons ? "auto" : "100%"}
                  marginBottom={small && SIZES.twenty}
                >
                  <Text
                    fontWeight={WEIGHT[small ? "regular" : "bold"]}
                    fontSize={small ? "14px" : "22px"}
                    textColor={small ? COLORS.lightGrey : "white"}
                    lineHeight="2"
                    margin="0"
                  >
                    {description}
                  </Text>
                </Box>
              </Grid>
              {!hideIcons && (
                <Grid item xs={12} md={6} style={{ paddingTop: 4 }}>
                  <Box display="flex" flexDirection="column" textAlign="left">
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="start"
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} lg={6}>
                          <Box display="flex" flexDirection={"column"}>
                            <Box
                              display="flex"
                              justifyContent="start"
                              alignItems="center"
                              marginBottom={small ? "20px" : "48px"}
                            >
                              <img
                                src={features[0].img}
                                alt={features[0].alt}
                                style={{ marginRight: 12, filter: "invert(1)" }}
                              />
                              <Text
                                fontSize={small ? "12px" : "20px"}
                                textColor={color ? color : "#707070"}
                                margin="0"
                                width="217px"
                              >
                                {features[0].title}
                              </Text>
                            </Box>
                            <Box
                              display="flex"
                              justifyContent="start"
                              alignItems="center"
                            >
                              <img
                                src={features[1].img}
                                alt={features[1].alt}
                                style={{ marginRight: 12, filter: "invert(1)" }}
                              />
                              <Text
                                fontSize={small ? "12px" : "20px"}
                                margin="0"
                                width="217px"
                                textColor={color ? color : "#707070"}
                              >
                                {features[1].title}
                              </Text>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <Box
                            display="flex"
                            flexDirection={"column"}
                            marginLeft={small || medium ? 0 : "40px"}
                          >
                            <Box
                              display="flex"
                              justifyContent="start"
                              alignItems="center"
                              marginBottom={small || medium ? "20px" : "48px"}
                            >
                              <img
                                src={features[2].img}
                                alt={features[2].alt}
                                style={{ marginRight: 12, filter: "invert(1)" }}
                              />
                              <Text
                                fontSize={small ? "12px" : "20px"}
                                textColor={color ? color : "#707070"}
                                margin="0"
                                width="217px"
                              >
                                {features[2].title}
                              </Text>
                            </Box>
                            {!isHiload && (
                              <Box
                                display={!isHiload ? "flex" : "none"}
                                justifyContent="start"
                                alignItems="center"
                              >
                                <img
                                  src={features[3].img}
                                  alt={features[3].alt}
                                  style={{
                                    marginRight: 12,
                                    filter: "invert(1)",
                                  }}
                                />
                                <Text
                                  fontSize={small ? "12px" : "20px"}
                                  textColor={color ? color : "#707070"}
                                  margin="0"
                                  width="217px"
                                >
                                  {features[3].title}
                                </Text>
                              </Box>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Grid>
              )}
            </>
          )}
        </Grid>
      </Box>
    </div>
  );
};

export default Sections;
